import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { usePmsComponents, PmsComponent } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<PmsComponent> useData={usePmsComponents} config={config} />;
};

export default List;
